import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Background from 'components/Background';

import { getAimsUrlFlavor } from 'lib/getAimsUrl';

// Temporarily leaving this stylesheet to handle grid only styles
// until different solution for grid is implemented within new theming strategy
import styles from './styles.module.scss';

function ShowLeadBackground({ imageUrl, imageUrlMobile }) {
  return (
    <React.Fragment>
      {!!imageUrlMobile && (
        <Background
          imageUrl={getAimsUrlFlavor(imageUrlMobile, { flavor: 'fit', width: 760 })}
          styleOverride={{
            bgWrapper: `show-lead-background__wrapper ${imageUrl ? 'show-lead-background__hide--on-large' : null}`,
            bgBackground: `${styles.background} show-lead-background__container`,
            bgPicture: 'show-lead-background__image',
            bgGradient: 'show-lead-background__hide',
          }}
          useBackground
        />
      )}
      {!!imageUrl && (
        <Background
          imageUrl={getAimsUrlFlavor(imageUrl, { flavor: 'fit', width: 1240 })}
          styleOverride={{
            bgWrapper: `show-lead-background__wrapper ${imageUrlMobile ? 'show-lead-background__hide--on-mobile' : null}`,
            bgBackground: `${styles.background} show-lead-background__container`,
            bgPicture: 'show-lead-background__image',
            bgGradient: 'show-lead-background__hide',
          }}
          useBackground
        />
      )}
      <div className={classNames(
        'show-lead-background__gradient',
        'absolute absolute-fill',
        { hasImage: typeof imageUrl !== 'undefined' || typeof imageUrlMobile !== 'undefined' },
      )}
      />
    </React.Fragment>
  );
}

ShowLeadBackground.propTypes = {
  imageUrl: PropTypes.string,
  imageUrlMobile: PropTypes.string,
};

ShowLeadBackground.defaultProps = {
  imageUrl: null,
  imageUrlMobile: null,
};

export default ShowLeadBackground;
